import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getInventories = async (form) => {
	const url = `${API_URL}/client/inventories`;

	try {
		const response = await axios.get(url, {
			params: form,
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

const uploadInventoriesExcel = async (form) => {
	const url = `${API_URL}/client/inventories/uploadInventoriesExcel`;

	try {
		const response = await axios.post(url, form, {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

const createInventoriesFromTags = async (inventories, search, page, paginate, defaultUnit, estate_id, typeCurrency) => {
	const url = `${API_URL}/client/inventories/create_from_tags`;

	const form = {
		inventories,
		defaultUnit,
		search,
		page,
		paginate,
		estate_id,
		type_currency: typeCurrency,
	};

	try {
		const response = await axios.post(url, form, {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response.data;
	} catch (error) {
		return error;
	}
};

export default {
	getInventories,
	uploadInventoriesExcel,
	createInventoriesFromTags,
};
